import { useEffect, useState } from "react";
import type { FeatureCollection, Geometry } from "geojson";

const WORLD_GEOJSON_URL = "/assets/geo/world.json";

let cachedPromise: Promise<FeatureCollection<Geometry>> | null = null;
let cachedData: FeatureCollection<Geometry> | null = null;

export function loadWorldGeoJSON(): Promise<FeatureCollection<Geometry>> {
  if (cachedPromise) return cachedPromise;
  cachedPromise = fetch(WORLD_GEOJSON_URL)
    .then((r) => {
      if (!r.ok) throw new Error(`world.json fetch failed: ${r.status}`);
      return r.json() as Promise<FeatureCollection<Geometry>>;
    })
    .then((data) => {
      cachedData = data;
      return data;
    })
    .catch((err) => {
      cachedPromise = null;
      throw err;
    });
  return cachedPromise;
}

export function getCachedWorldGeoJSON(): FeatureCollection<Geometry> | null {
  return cachedData;
}

export function useWorldGeoJSON():
  | FeatureCollection<Geometry>
  | undefined {
  const [data, setData] = useState<FeatureCollection<Geometry> | undefined>(
    () => cachedData ?? undefined,
  );

  useEffect(() => {
    if (data) return;
    let cancelled = false;
    loadWorldGeoJSON()
      .then((d) => {
        if (!cancelled) setData(d);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [data]);

  return data;
}
